import { Injectable } from '@angular/core';
import { MultiselectProvider } from '../multiselect-provider';
import { Observable, Observer } from 'rxjs';
import { MultiselectOptionItem, UiConstants } from '../../util/core-utils';
import { Set } from 'immutable';
import { OrderType, QueryResult } from '../util/services';
import { EmailTemplate, EmailTemplateService } from './email-template.service';

@Injectable()
export class EmailTemplateMultiselectProvider implements MultiselectProvider {

  private multiselectQueryRequest: EmailTemplate.QueryRequest = {
    paging: {
      pageNumber: 1,
      numberOfItems: UiConstants.autocompletePageSize
    },
    noProgressBar: true,
    orders: Set.of({field: EmailTemplate.OrderField.NAME, type: OrderType.ASC}),
    disabled: undefined,
    name: undefined
  };

  constructor(private service: EmailTemplateService) {
  }

  load(queryRequest: EmailTemplate.QueryRequest): Observable<MultiselectOptionItem<number>[]> {
    return Observable.create((observer: Observer<MultiselectOptionItem<number>[]>) => {
      this.service.query(queryRequest).subscribe((result: QueryResult<EmailTemplate.EmailTemplate>) => {
        observer.next(result.items.map(item => this.toMultiselectOptionItem(item!)).toArray());
        },
        (error: Error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        });
    });
  }

  loadEmailTemplates(disabled?: boolean, query?: string): Observable<MultiselectOptionItem<number>[]> {
    const queryRequest = Object.assign([], this.multiselectQueryRequest);
    queryRequest.disabled = disabled;
    queryRequest.name = query;
    return this.load(this.multiselectQueryRequest);
  }

  getById(id: number): Observable<MultiselectOptionItem<number>> {
    return Observable.create((observer: Observer<MultiselectOptionItem<number>>) => {
      this.service.get({
        id: id
      }).subscribe((result: EmailTemplate.EmailTemplate) => {
          observer.next(this.toMultiselectOptionItem(result!));
        },
        (error: Error) => {
          observer.error(error);
        },
        () => {
          observer.complete();
        });
    });
  }

  getByIds(ids: number[]): Observable<MultiselectOptionItem<number>[]> {
    const queryRequest = Object.assign([], this.multiselectQueryRequest);
    queryRequest.id = Set.of(...ids);
    queryRequest.paging = undefined;
    return this.load(queryRequest);
  }

  toMultiselectOptionItem(item: EmailTemplate.EmailTemplate): MultiselectOptionItem<number> {
    const ret = new MultiselectOptionItem<number>();
    ret.id = item.id;
    ret.itemName = item.name;
    ret.disabled = item.disabled;
    return ret;
  }

}
